module.exports = __webpack_public_path__ + "img/contacts-select.854e33ab.png";